import { render, staticRenderFns } from "./SourceLegend.vue?vue&type=template&id=7e4b3b8e"
import script from "./SourceLegend.vue?vue&type=script&lang=js"
export * from "./SourceLegend.vue?vue&type=script&lang=js"
import style0 from "./SourceLegend.vue?vue&type=style&index=0&id=7e4b3b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports